module.exports = __webpack_public_path__ + "public/images/Outschool_Logo_White.bc502d0619fd840e1e341a7dd42d78b4.svg";